/*******************************************************************************************
Sheet Stock
******************************************************************************************
  --thickness <float> | inches | required
  --length <float> | inches | required
  --width <float> | inches | required
  --certification <string::enum> | ['FSC', 'NAUF', 'Standard'] | default = 'Standard'

Single Manufacturer
  /Flexible Materials
    --bend <float> | inches | ('Inches of Bend')
    --coreType <string::combobox>
    --insideRadius <float> | inches
    --outsideRadius <float> | inches
    --manufacturer <Manufacturer>
    --manufacturerNumber <string>
    --computerEaseNumber <string>

  /Laminate
    --manufacturer <Manufacturer>
    --manufacturerNumber <string>
    --computerEaseNumber <string>

  /Plastics
    --fireRated <boolean::checkbox>
    --manufacturer <Manufacturer>
    --manufacturerNumber <string>
    --computerEaseNumber <string>

  /Solid Surface
    --manufacturer <Manufacturer>
    --manufacturerNumber <string>
    --computerEaseNumber <string>

  /Veneer

/Multiple Manufacturers

  /MDF
    --moistureResistant <boolean::checkbox>
    --fireRated <boolean::checkbox>
    --manufacturers {
      --manufacturer <Manufacturer>
      --manufacturerNumber <string>
      --computerEaseNumber <string>
    }

  /Melamine
    --fireRated <boolean::checkbox>
    --manufacturers {
      --manufacturer <Manufacturer>
      --manufacturerNumber <string>
      --computerEaseNumber <string>
    }

  /Particle Board
    --moistureResistant <boolean::checkbox>
    --fireRated <boolean::checkbox>
    --manufacturers {
      --manufacturer <Manufacturer>
      --manufacturerNumber <string>
      --computerEaseNumber <string>
    }

  /Plywood
    --moistureResistant <boolean::checkbox>
    --fireRated <boolean::checkbox>
    --weight <float> | lbs/sqft | (per sheet, by lbs/sqft)
    --manufacturers {
      --manufacturer <Manufacturer>
      --manufacturerNumber <string>
      --computerEaseNumber <string>
    }

  /Protective Materials
    --moistureResistant <boolean::checkbox>
    --fireRated <boolean::checkbox>
    --manufacturers {
      --manufacturer <Manufacturer>
      --manufacturerNumber <string>
      --computerEaseNumber <string>
    }
*/
const name = 'Sheet Stock'
const id = 'SqpyMOgJY3MtrqxHDqm1'

export default {
  name,
  id
}
